import React from 'react';
import { EMPTY } from 'rxjs';
import { defineMessages, FormattedMessage } from 'react-intl';
import { DocumentType } from '../../../enums/document-type';

const messages = defineMessages({
  printingCustomsFormsSuccessTitle: {
    description: 'printEpics.printingCustomsFormsSuccessTitle',
    defaultMessage: 'Printing {docCount, plural,=0 {Customs Form} one {Customs Form} other {Customs Forms}}...',
    id: 'nyEjyg',
  },
  printingCustomsFormsSuccessContent: {
    description: 'printEpics.printingCustomsFormsSuccessContent',
    defaultMessage: '{docCount, plural,=0 {Customs Form} one {Customs Form} other {Customs Forms}} sent to {printerName}.',
    id: '5Fn3vc',
  },
  downloadCustomsFormssStartedTitle: {
    description: 'printEpics.downloadCustomsFormssStartedTitle',
    defaultMessage: 'Downloading {docCount, plural,=0 {Customs Form} one {Customs Form} other {Customs Forms}}...',
    id: 'EjlGfk',
  },
  downloadCustomsFormssStartedContent: {
    description: 'printEpics.downloadCustomsFormssStartedContent',
    defaultMessage: '{docCount, plural,=0 {Customs Form} one {Customs Form} other {Customs Forms}} Download Started.',
    id: 'cUNBh7',
  },
  downloadCustomsFormssCompletedTitle: {
    description: 'printEpics.downloadCustomsFormssCompletedTitle',
    defaultMessage: 'Downloading {docCount, plural,=0 {Customs Form} one {Customs Form} other {Customs Forms}}...',
    id: 'oL71/c',
  },
  downloadCustomsFormssCompletedContent: {
    description: 'printEpics.downloadCustomsFormssCompletedContent',
    defaultMessage: '{docCount, plural,=0 {Customs Form} one {Customs Form} other {Customs Forms}} Download Completed.',
    id: 'T77xjJ',
  },
});

export const batchCustomsForms = {
  id: DocumentType.BatchCustomsForm.identifier,

  getDownloadStartedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadCustomsFormssStartedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadCustomsFormssStartedContent} values={{ docCount }} />,
  }),

  getDownloadCompletedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadCustomsFormssCompletedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadCustomsFormssCompletedContent} values={{ docCount }} />,
  }),

  getPrintedSuccessNotificationProps: (docCount, printerName) => ({
    title: <FormattedMessage {...messages.printingCustomsFormsSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.printingCustomsFormsSuccessContent} values={{ docCount, printerName }} />,
  }),

  getPrintedSuccessObservable: () => {
    return EMPTY;
  },
};
